import { z } from "zod";
import { ACCOUNT_KIND } from "../enums.js";
import { booleanFlag, dateRange, listQuery, objectId } from "./common.js";
/**
 * Ledger read contracts.
 *
 * There is deliberately NO "create ledger entry" schema. Entries are never authored
 * directly — they are produced by a posting service from a business transaction, in a
 * balanced set, inside one database transaction. Exposing an endpoint that writes a
 * single entry would be an endpoint for putting the books out of balance.
 */
export const ledgerAccountQuerySchema = listQuery.extend({
    kind: z.nativeEnum(ACCOUNT_KIND).optional(),
    /** Hide accounts with no entries and a zero balance — the trial balance's usual view. */
    activeOnly: booleanFlag.optional(),
});
export const ledgerEntryQuerySchema = listQuery
    .extend({
    ledgerAccountId: objectId.optional(),
    transactionId: objectId.optional(),
})
    .and(dateRange);
/**
 * A statement page. `newest` lists the latest entry first; the running balance on each
 * row is still the balance AFTER that entry, so it reads correctly in either order.
 */
export const ledgerStatementQuerySchema = ledgerEntryQuerySchema.and(z.object({ newest: booleanFlag.optional() }));
/** Entries across every account of the given kinds — the "All" view of a ledger book. */
export const ledgerKindEntriesQuerySchema = ledgerStatementQuerySchema.and(z.object({
    kinds: z
        .string()
        .trim()
        .min(1)
        .transform((v) => v.split(",").map((k) => k.trim()).filter(Boolean))
        .pipe(z.array(z.nativeEnum(ACCOUNT_KIND)).min(1)),
}));
//# sourceMappingURL=ledger.js.map